module.exports = __webpack_public_path__ + "0.1.2/img/mean-friend.a691fa06.jpg";